import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import { BooleanInput } from 'ng-zorro-antd/core/types';
import { InputBoolean } from 'ng-zorro-antd/core/util';
import { collapseMotion } from './typing';
@Component({
  selector: 'm-collapse',
  exportAs: 'mCollapse',
  animations: [collapseMotion],
  template: `
    <div class="m-collapse-header" [attr.aria-expanded]="mActive" (click)="clickHeader()">
      <ng-container *nzStringTemplateOutlet="mExpandedIcon">
        {{ mExpandedIcon }}
      </ng-container>
      <ng-container *nzStringTemplateOutlet="mHeader">{{ mHeader }}</ng-container>
      <div class="m-collapse-extra" *ngIf="mExtra">
        <ng-container *nzStringTemplateOutlet="mExtra">{{ mExtra }}</ng-container>
      </div>
    </div>
    <div class="m-collapse-content" [@collapseMotion]="mActive ? 'expanded' : 'hidden'">
      <div class="m-collapse-content-box">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false,
  host: {
    class: 'm-collapse',
    '[class.m-collapse-disabled]': 'mDisabled'
  }
})
export class MCollapseComponent {
  static ngAcceptInputType_mActive: BooleanInput;
  static ngAcceptInputType_mDisabled: BooleanInput;

  @Input() mHeader?: string | TemplateRef<void>;
  @Input() mExtra?: string | TemplateRef<void>;
  @Input() @InputBoolean() mDisabled = false;
  @Input() @InputBoolean() mActive = false;
  @Input() mExpandedIcon?: string | TemplateRef<void>;

  @Output() readonly mActiveChange = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef) {}

  clickHeader(): void {
    if (!this.mDisabled) {
      this.mActive = !this.mActive;
      this.mActiveChange.emit(this.mActive);
    }
  }

  markForCheck(): void {
    this.cdr.markForCheck();
  }
}
